'use client';

import dynamic from 'next/dynamic';

const GoogleAnalytics = dynamic(() => import('@next/third-parties/google').then(mod => mod.GoogleAnalytics), { ssr: false });

const GA_MEASUREMENT_ID = 'G-FQMFEN0QZ1';

const GoogleAnalyticsWrapper = () => {
  return <GoogleAnalytics gaId={GA_MEASUREMENT_ID} />;
};

export default GoogleAnalyticsWrapper;
